<template>
    <vs-popup class="add-new-incoterms" id="popup" title="OPPORTUNITY ASSESSMENT HISTORY" @close="open = false" :active.sync="open"
        :buttons-hidden="true">
        <vx-card no-shadow>
            <vs-table :data="data_list">

                <template slot="thead">
                    <vs-th>BUDGET</vs-th>
                    <vs-th>AUTHORITY</vs-th>
                    <vs-th>NEED</vs-th>
                    <vs-th>TIMESCALE</vs-th>
                    <vs-th width="15%">REASON</vs-th>
                    <vs-th width="15%">COMMENTS</vs-th>
                    <vs-th>OPPORTUNITY STATUS</vs-th>
                    <vs-th>CREATED BY</vs-th>
                    <vs-th>DATE/TIME</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].budget">
                            {{ data[indextr].budget }}
                        </vs-td>

                        <vs-td :data="data[indextr].authority">
                            {{ data[indextr].authority }}
                        </vs-td>

                        <vs-td :data="data[indextr].need">
                            {{ data[indextr].need }}
                        </vs-td>

                        <vs-td :data="data[indextr].timescale">
                            {{ data[indextr].timescale }} {{ data[indextr].timescale_type || '' }}
                        </vs-td>

                        <vs-td :data="data[indextr].reason">
                            {{ data[indextr].reason }}
                        </vs-td>

                        <vs-td :data="data[indextr].comment">
                            {{ data[indextr].comment }}
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip :color="data[indextr].status === 'Accepted' ? 'primary' : 'danger'" transparent>
                                {{ data[indextr].status }}
                            </vs-chip>
                        </vs-td>

                        <vs-td :data="data[indextr].created_by_staff">
                            {{ data[indextr].created_by_staff }}
                        </vs-td>

                        <vs-td>
                            {{ __dateTimeFormatterToDate(data[indextr].created_at) }}
                        </vs-td>
                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        id: '',
        data_list: [],
    }
}

export default {
    name: 'ViewOpportunityBantDataPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true;
                this.id = id
                await this.fetchBantData()
            } catch (error) {

            }
        },
        async fetchBantData() {
            try {
                const { data } = await CrmRepository.getBantDataForOpportunity(this.id)
                this.data_list = data.data
            } catch (error) {
                this.convertAndNotifyError(error);
            }
        },
    },
    components: {
        'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    min-height: 30% !important;
    min-width: 70% !important;
}
</style>
  